import { buildQuery, parseQuery } from '@calendly/http-tools'

import { dateUrlParamsSelector, spotUrlParamsSelector } from 'selectors'
import { eventTypePathSelector } from 'selectors/url'

const historyReplace = (path) => (dispatch, getState, { history }) => history.replace(path)

const getSearch = (history) => history.location.search

export const setGetParams = (params) => (dispatch, getState, { history }) => {
  const searchParams = parseQuery(history.location.search)
  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      delete searchParams[key]
    } else {
      searchParams[key] = value
    }
  })

  const searchStr = buildQuery(searchParams, { addQueryPrefix: true })
  return dispatch(historyReplace({ search: searchStr }))
}

export const syncUrlParameters = (duration) => (dispatch, getState) => {
  const dateUrlParams = dateUrlParamsSelector(getState())
  const params = dateUrlParams

  if (duration) {
    params.duration = duration
  }

  dispatch(setGetParams(params))
}

export const syncSpotUrlParameters = () => (dispatch, getState) => {
  const spotsUrlParams = spotUrlParamsSelector(getState())
  dispatch(setGetParams(spotsUrlParams))
}

export const addSegment = (segment) => (dispatch, getState, { history }) => (
  history.push(`${eventTypePathSelector(getState())}/${segment}${getSearch(history)}`)
)
